import "./WhatsAppChat.css";
import { useBrand, whatsappHref } from "../brand/BrandContext";

function WhatsAppChat() {
  const brand = useBrand();
  if (!brand.whatsapp) return null;
  return (
    <a
      href={whatsappHref(brand.whatsapp, "Hello I have a query regarding travel packages")}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      💬
    </a>
  );
}

export default WhatsAppChat;
